/**
 * Application Configuration
 * Core application constants and settings for the restaurant website
 */

// Application Information
export const APP_INFO = {
  NAME: "Restaurant Website",
  VERSION: "1.0.0",
  DESCRIPTION: "Modern restaurant website with dynamic content",
  AUTHOR: "Cashless Ai Team",
} as const;

// Application Settings
export const APP_SETTINGS = {
  DEFAULT_LANGUAGE: "en" as const,
  THEME: "light" as const,
  TIMEZONE: "UTC" as const,
  DATE_FORMAT: "YYYY-MM-DD" as const,
  TIME_FORMAT: "24h" as const,
} as const;

// Type definitions for better TypeScript support
export type AppTheme = typeof APP_SETTINGS.THEME;
export type AppLanguage = typeof APP_SETTINGS.DEFAULT_LANGUAGE;
export type TimeFormat = typeof APP_SETTINGS.TIME_FORMAT;
